/* istanbul ignore file */
import type { Font } from '@noths/polaris-client-ribbons-base';
import { createGlobalStyle, css } from 'styled-components';

import { dggTheme } from '../styles/dggTheme';

const { fonts, colors } = dggTheme;

export const breakpoint = 970;

export const fontFace = ({ family, formats: { ttf }, weight }: Font) => css`
  @font-face {
    font-family: '${family}';
    font-display: swap;
    font-style: normal;
    font-weight: ${weight};
    src: url('${ttf}');
  }
`;

export const generateBaseStyles = () => createGlobalStyle`
    ${fontFace(fonts.PRIMARY_REGULAR)}
    ${fontFace(fonts.PRIMARY_SEMIBOLD)}

    :root {
      --dgg-moody-blue: ${colors.moodyBlue};
      --dgg-well-read: ${colors.wellRead};
      --dgg-paris-m: ${colors.parisM};
      --dgg-neutral-white: ${colors.neutralWhite};
    }

    main {
      overflow-x: hidden;
    }

    body {
      background-color: var(--dgg-well-read);
    }
`;
